import React, { useState } from 'react';
import { TEAM } from '../lib/constants';
import { avInitials } from '../lib/utils';

const AV_GRADIENTS = {
  Arshad:  'linear-gradient(135deg,#0EA5E9,#0369A1)',
  Fahad:   'linear-gradient(135deg,#6366F1,#3730A3)',
  Prateek: 'linear-gradient(135deg,#F59E0B,#B45309)',
  Utkarsh: 'linear-gradient(135deg,#EC4899,#9D174D)',
  Zeba:    'linear-gradient(135deg,#A855F7,#6B21A8)',
  Azmath:  'linear-gradient(135deg,#10B981,#065F46)',
};

export default function WhoModal({ open, saving, onClose, onConfirm }) {
  const [selected, setSelected] = useState(null);

  if (!open) return null;

  const handleConfirm = () => { if (selected) onConfirm(selected); };

  return (
    <div style={styles.backdrop} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={styles.modal}>
        <div style={styles.head}>
          <div>
            <h2 style={styles.title}>One last thing — who's saving?</h2>
            <p style={styles.sub}>Tap your name. We log it so the team can see who changed what.</p>
          </div>
          <button onClick={onClose} style={styles.closeBtn}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="16" height="16">
              <path d="M18 6 6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <div style={styles.body}>
          <div style={styles.grid}>
            {TEAM.map(name => (
              <button
                key={name}
                onClick={() => setSelected(name)}
                style={{
                  ...styles.whoBtn,
                  borderColor: selected === name ? '#0A2540' : '#E4ECF4',
                  background: selected === name ? '#0A2540' : 'white',
                  color: selected === name ? 'white' : '#0A2540',
                }}
              >
                <span style={{ ...styles.av, background: selected === name ? 'rgba(255,255,255,.2)' : AV_GRADIENTS[name] }}>
                  {avInitials(name)}
                </span>
                <span style={styles.whoName}>{name}</span>
              </button>
            ))}
          </div>
        </div>

        <div style={styles.foot}>
          <span style={styles.footNote}>Stored locally · Backed up to Supabase on connect</span>
          <button
            onClick={handleConfirm}
            disabled={!selected || saving}
            style={{ ...styles.btnPrimary, opacity: !selected || saving ? 0.5 : 1, cursor: !selected || saving ? 'not-allowed' : 'pointer' }}
          >
            {saving ? 'Saving…' : 'Confirm & save'}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  backdrop: { position:'fixed', inset:0, background:'rgba(10,37,64,.4)', backdropFilter:'blur(4px)', zIndex:110, display:'flex', alignItems:'center', justifyContent:'center', padding:20, animation:'fadeIn .2s ease' },
  modal: { background:'white', borderRadius:18, width:'100%', maxWidth:420, boxShadow:'0 32px 64px -16px rgba(10,37,64,.3)', animation:'modalIn .3s cubic-bezier(.4,0,.2,1)' },
  head: { padding:'22px 26px 18px', borderBottom:'1px solid #E4ECF4', display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:12 },
  title: { fontFamily:"'Fraunces',serif", fontWeight:500, fontSize:22, letterSpacing:'-0.02em', margin:0 },
  sub: { marginTop:4, fontSize:13, color:'#3D5878' },
  closeBtn: { width:30, height:30, display:'grid', placeItems:'center', borderRadius:8, color:'#7A8BA3', background:'none', border:'none', cursor:'pointer' },
  body: { padding:'22px 26px' },
  grid: { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 },
  whoBtn: { display:'flex', flexDirection:'column', alignItems:'center', gap:6, padding:'12px 8px', border:'2px solid', borderRadius:10, cursor:'pointer', transition:'all .15s ease', fontFamily:"'Geist',sans-serif" },
  av: { width:30, height:30, borderRadius:'50%', display:'grid', placeItems:'center', color:'white', fontSize:12, fontWeight:600 },
  whoName: { fontSize:11.5, fontWeight:500 },
  foot: { padding:'14px 26px', borderTop:'1px solid #E4ECF4', display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, background:'#F7FAFD', borderRadius:'0 0 18px 18px' },
  footNote: { fontSize:11.5, color:'#7A8BA3' },
  btnPrimary: { display:'inline-flex', alignItems:'center', padding:'10px 16px', borderRadius:10, fontSize:13, fontWeight:500, background:'#0A2540', color:'white', border:'none', transition:'opacity .15s ease' },
};
